import { createContext } from 'react'

export const WorkspaceBarContext = createContext(null)
